/**
 * Riitan pesula – tuotesivun suodattimet.
 * Suodatus koskee koko kokoelmaa. Sivunumerot säilyttävät haun.
 */
(function () {
  'use strict';

  var grid = document.getElementById('ri-products-grid');
  if (!grid) return;

  var PER_PAGE = 50;
  var filters = {
    search: document.getElementById('ri-filter-search'),
    category: document.getElementById('ri-filter-category'),
    priceMin: document.getElementById('ri-filter-price-min'),
    priceMax: document.getElementById('ri-filter-price-max')
  };
  var countEl = document.getElementById('ri-products-count');
  var pageRoot = grid.closest('.ri-page');
  var allCards = null;
  var loading = null;
  var timer = null;

  function readFields() {
    var maxRaw = filters.priceMax ? filters.priceMax.value.trim() : '';
    var minRaw = filters.priceMin ? filters.priceMin.value.trim() : '';
    var searchRaw = filters.search ? filters.search.value.trim() : '';
    var maxVal = maxRaw === '' ? Infinity : parseFloat(maxRaw);
    if (isNaN(maxVal)) maxVal = Infinity;
    return {
      searchRaw: searchRaw,
      search: searchRaw.toLowerCase(),
      cat: filters.category ? filters.category.value : '',
      minRaw: minRaw,
      maxRaw: maxRaw,
      minVal: minRaw === '' ? 0 : (parseFloat(minRaw) || 0),
      maxVal: maxVal
    };
  }

  function hasFilter(fields) {
    return !!(fields.searchRaw || fields.cat || fields.minRaw || fields.maxRaw);
  }

  function matches(card, fields) {
    var title = (card.dataset.title || '').toLowerCase();
    var matchSearch = !fields.search || title.indexOf(fields.search) !== -1;
    var matchCat = !fields.cat || card.dataset.category === fields.cat;
    var price = parseFloat(card.dataset.priceValue) || 0;
    return matchSearch && matchCat && price >= fields.minVal && price <= fields.maxVal;
  }

  function pageFromUrl(url) {
    var params = new URL(url, window.location.origin).searchParams;
    var page = parseInt(params.get('page') || '1', 10);
    return page > 0 ? page : 1;
  }

  function buildUrl(page, fields) {
    var url = new URL(window.location.href);
    url.searchParams.delete('ri_q');
    url.searchParams.delete('ri_cat');
    url.searchParams.delete('ri_min');
    url.searchParams.delete('ri_max');
    url.searchParams.delete('page');
    if (fields.searchRaw) url.searchParams.set('ri_q', fields.searchRaw);
    if (fields.cat) url.searchParams.set('ri_cat', fields.cat);
    if (fields.minRaw) url.searchParams.set('ri_min', fields.minRaw);
    if (fields.maxRaw) url.searchParams.set('ri_max', fields.maxRaw);
    if (page > 1) url.searchParams.set('page', String(page));
    return url.pathname + url.search;
  }

  function unfilteredPageUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.delete('ri_q');
    url.searchParams.delete('ri_cat');
    url.searchParams.delete('ri_min');
    url.searchParams.delete('ri_max');
    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  function maxPage(doc) {
    var max = 1;
    doc.querySelectorAll('.ri-pagination a').forEach(function (link) {
      var page = pageFromUrl(link.getAttribute('href') || '');
      if (page > max) max = page;
    });
    return max;
  }

  function cardsIn(doc) {
    return Array.prototype.slice.call(doc.querySelectorAll('#ri-products-grid .ri-product-card-wrapper'));
  }

  function loadAll() {
    if (allCards) return Promise.resolve(allCards);
    if (loading) return loading;

    var last = maxPage(document);
    var jobs = [];
    for (var page = 1; page <= last; page++) {
      jobs.push(fetch(unfilteredPageUrl(page), { credentials: 'same-origin' }).then(function (response) {
        return response.text();
      }));
    }

    loading = Promise.all(jobs).then(function (pages) {
      var cards = [];
      pages.forEach(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        cards = cards.concat(cardsIn(doc));
      });
      allCards = cards;
      loading = null;
      return cards;
    }).catch(function (error) {
      loading = null;
      throw error;
    });

    return loading;
  }

  function pager(pageCount, page, fields) {
    var nav = pageRoot ? pageRoot.querySelector('.ri-pagination') : null;
    if (pageCount <= 1) {
      if (nav) nav.hidden = true;
      return;
    }
    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'ri-pagination';
      nav.setAttribute('aria-label', 'Sivutus');
      if (pageRoot) pageRoot.appendChild(nav);
    }
    nav.hidden = false;

    var html = '';
    if (page > 1) {
      html += '<a href="' + buildUrl(page - 1, fields) + '">Edellinen</a>';
    }
    for (var i = 1; i <= pageCount; i++) {
      if (i === page) html += '<span aria-current="page">' + i + '</span>';
      else html += '<a href="' + buildUrl(i, fields) + '">' + i + '</a>';
    }
    if (page < pageCount) {
      html += '<a href="' + buildUrl(page + 1, fields) + '">Seuraava</a>';
    }
    nav.innerHTML = html;
  }

  function show(cards, page, fields) {
    var pageCount = Math.max(1, Math.ceil(cards.length / PER_PAGE));
    var current = Math.min(Math.max(page, 1), pageCount);
    var slice = cards.slice((current - 1) * PER_PAGE, current * PER_PAGE);
    grid.replaceChildren.apply(grid, slice);
    pager(pageCount, current, fields);
    if (countEl) countEl.textContent = slice.length + ' tuotetta';
  }

  function applyFiltered(resetPage) {
    var fields = readFields();
    if (!hasFilter(fields)) {
      window.location.href = unfilteredPageUrl(1);
      return;
    }

    var page = resetPage ? 1 : pageFromUrl(window.location.href);
    loadAll().then(function (cards) {
      var matched = cards.filter(function (card) {
        return matches(card, fields);
      });
      var pageCount = Math.max(1, Math.ceil(matched.length / PER_PAGE));
      var current = Math.min(Math.max(page, 1), pageCount);
      history.replaceState(null, '', buildUrl(current, fields));
      show(matched, current, fields);
    }).catch(function () {
      var local = cardsIn(document).filter(function (card) {
        return matches(card, fields);
      });
      show(local, 1, fields);
    });
  }

  function schedule(resetPage) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      applyFiltered(resetPage);
    }, 250);
  }

  function restoreFields() {
    var params = new URLSearchParams(window.location.search);
    if (filters.search && params.has('ri_q')) filters.search.value = params.get('ri_q');
    if (filters.category && params.has('ri_cat')) filters.category.value = params.get('ri_cat');
    if (filters.priceMin && params.has('ri_min')) filters.priceMin.value = params.get('ri_min');
    if (filters.priceMax && params.has('ri_max')) filters.priceMax.value = params.get('ri_max');
  }

  Object.keys(filters).forEach(function (key) {
    var el = filters[key];
    if (!el) return;
    el.addEventListener('input', function () {
      schedule(true);
    });
    el.addEventListener('change', function () {
      schedule(true);
    });
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.ri-pagination a');
    if (!link || !hasFilter(readFields())) return;
    event.preventDefault();
    var page = pageFromUrl(link.getAttribute('href') || link.href);
    history.pushState(null, '', buildUrl(page, readFields()));
    applyFiltered(false);
  });

  window.addEventListener('popstate', function () {
    restoreFields();
    if (hasFilter(readFields())) applyFiltered(false);
    else window.location.href = unfilteredPageUrl(pageFromUrl(window.location.href));
  });

  restoreFields();
  if (hasFilter(readFields())) applyFiltered(false);
  else if (countEl) countEl.textContent = cardsIn(document).length + ' tuotetta';
})();
